import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.SupplierSelector.';
  public static readonly supplier = `${Id.prefix}supplier`;
  public static readonly selectQuoteSupplier = `${Id.prefix}selectQuoteSupplier`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangSupplierSelector {
  private constructor() {}
  public static supplier(): string {
    return interpolate(Id.supplier);
  }
  public static selectQuoteSupplier(): string {
    return interpolate(Id.selectQuoteSupplier);
  }
}

export class SupplierSelectorModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.supplier, "{{glossary 'supplier'}}", 'Singular supplier glossary term');
    register.add(
      Id.selectQuoteSupplier,
      "Select {{glossary 'quote'}} {{glossary 'supplier'}}",
      'Title for quote supplier selection modal'
    );
  }
}
